import { html } from 'lit';

import { renderGamAd } from '@client/adManager/AdUnit/renderAd.js';
import { AdVendor } from '@client/core/AdVendor.js';
import { AdServer, type PlacementId } from '@schibsted-nmp/advertising-shared';

export class GamAdVendor extends AdVendor {
  constructor(placementId: PlacementId) {
    super(AdServer.Gam, placementId, `${placementId}--container`);
  }

  override updated() {
    // do nothing
  }

  override cleanupEvents() {
    // do nothing
  }

  override setupEvents() {
    // do nothing
  }

  override requestAd() {
    renderGamAd({
      placementId: this.placementId,
      containerId: this.containerId || `${this.placementId}--container`
    });
  }

  override render() {
    return html`
      <slot
        name="${`${this.placementId}--slot`}"
        id="${this.placementId}"
      ></slot>
    `;
  }
}
